import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  private _isSidebarOpen = signal(false);
  private _isFilterMenuOpen = signal(false);

  readonly isSidebarOpen = computed(() => this._isSidebarOpen());
  readonly isFilterMenuOpen = computed(() => this._isFilterMenuOpen());


  toggle() {
    this._isSidebarOpen.update(open => {
      if (!open) {
        this._isFilterMenuOpen.set(false);
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
      return !open;
    });
  }

  open() {
    this._isFilterMenuOpen.set(false);
    this._isSidebarOpen.set(true);
    document.body.style.overflow = 'hidden';
  }

  close() {
    this._isSidebarOpen.set(false);
    document.body.style.overflow = '';
  }

  // Filter Menu methods
  toggleFilterMenu() {
    this._isFilterMenuOpen.update(open => !open);
  }

  openFilterMenu() {
    this._isSidebarOpen.set(false);
    this._isFilterMenuOpen.set(true);
  }

  closeFilterMenu() {
    this._isFilterMenuOpen.set(false);
  }
}
